export enum PaymentType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
  BOTH = 'BOTH'
}
